import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./uploadusers.css";

const UploadUsers = () => {
  const [file, setFile] = useState(null);
  const [programs, setPrograms] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState("");
  const [message, setMessage] = useState("");
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSummary, setShowSummary] = useState(true);

const navigate = useNavigate();


// Fully random strong password


  useEffect(() => {
    axios.get("/api/adminprograms")
      .then((res) => setPrograms(res.data))
      .catch((err) => console.error("Error fetching programs:", err));
  }, []);

  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleUpload = async () => {
    if (!selectedProgram) return setMessage("⚠️ Please select a program.");
    if (!file) return setMessage("⚠️ Please select a file.");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("programId", selectedProgram);

    setLoading(true);
    setMessage("");

    try {
      const res = await axios.post("/api/admin/upload-participants", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      /*setSummary(res.data.summary || null);
      setMessage(res.data.message || "Upload successful!");
*/

setSummary(res.data.summary || null);
setMessage(res.data.message || "Upload successful!");

if (res.data.passwordFile) {
  const byteCharacters = atob(res.data.passwordFile);
  const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) =>
    byteCharacters.charCodeAt(i)
  );
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "Generated_User_Passwords.xlsx";
  link.click();
}
    } catch (err) {
      setMessage("❌ Upload failed");
      console.error(err);
    }

    setLoading(false);
  };
const handleCancel = () => {
  setFile(null);
  setSelectedProgram("");
  setMessage("");
  setSummary(null);
  setShowSummary(true);
  setLoading(false);

  navigate("/admin/home");

  // reset file input manually
  const fileInput = document.querySelector(".file-input");
  if (fileInput) fileInput.value = "";
};

  return (
  <div className="upload-users-container">

    {/* Upload Form */}
    <div className="upload-box">
      <h5>
        <span className="icon"></span> Upload User Data
      </h5>

      <select
        value={selectedProgram}
        onChange={(e) => setSelectedProgram(e.target.value)}
        className="program-select"
      >
        <option value="">-- Select Program --</option>
        {programs.map((p) => (
          <option key={p.program_id} value={p.program_id}>
            {p.program_name} ({p.feedback_type})
          </option>
        ))}
      </select>

      <input
        type="file"
        accept=".xls, .xlsx"
        onChange={handleFileChange}
        className="file-input"
      />

      {/* <button onClick={handleUpload} className="upload-btn">
        {loading ? <span className="loader"></span> : "Upload File"}
      </button> */}

<div className="action-buttons">
  <button
    onClick={handleUpload}
    className="upload-btn"
    disabled={loading}
  >
    {loading ? <span className="loader"></span> : "Upload"}
  </button>

  <button
    onClick={handleCancel}
    className="cancel-btn"
    disabled={loading}
  >
    Cancel
  </button>
</div>

      {message && <p className="upload-message">{message}</p>}


    </div>

    {/* Summary Below */}
{/* Summary Below */}
{summary && (
  <div className="summary-wrapper">
    <div className="summary-container fade-in">

      <div className="summary-header" onClick={() => setShowSummary(!showSummary)}>
        <h6>📊 Upload Summary</h6>
        <span className="toggle-icon">{showSummary ? "▲" : "▼"}</span>
      </div>

      <div className={`summary-body ${showSummary ? "open" : ""}`}>

        {/* Basic Counts */}
        <ul>
          <li>📄 Rows Processed: {summary.rowsProcessed}</li>
          <li>👤 Users Created: {summary.usersCreated}</li>
          <li>🧾 Enrollments Created: {summary.enrollmentsCreated}</li>
          <li>🔗 Relationships Created: {summary.relationshipsCreated}</li>
        </ul>

        {/* Total Unique Users */}
        {summary.totalUniqueUsers && (
          <p className="summary-info">
            👥 <strong>Total Unique Users:</strong> {summary.totalUniqueUsers}
          </p>
        )}

        {/* ❌ Duplicate Emails — Blocking Error */}
        {summary.duplicateEmails && summary.duplicateEmails.length > 0 && (
          <div className="upload-errors">
            <h6>❌ Duplicate Email IDs — Upload Stopped</h6>
            <ul>
              {summary.duplicateEmails.map((e, i) => (
                <li key={i}>Row {e.row}: <strong>{e.email}</strong></li>
              ))}
            </ul>
          </div>
        )}

        {/* ⚠ Duplicate Names */}
        {summary.duplicateNames && summary.duplicateNames.length > 0 && (
          <div className="upload-warnings">
            <h6>⚠ Duplicate Names (same name but different emails)</h6>
            <ul>
              {summary.duplicateNames.map((n, i) => (
                <li key={i}>{n.name} — Appears {n.count} times</li>
              ))}
            </ul>
          </div>
        )}

        {/* ⚠ Regular Warnings */}
        {summary.warnings?.length > 0 && (
          <div className="upload-warnings">
            <h6>⚠ Warnings</h6>
            <ul>
              {summary.warnings.map((w, i) => (
                <li key={i}>{w}</li>
              ))}
            </ul>
          </div>
        )}

      </div>

    </div>
  </div>
)}

  </div>
);

};

export default UploadUsers;
